import { render, staticRenderFns } from "./FitbackLoverDataTable.vue?vue&type=template&id=80b7b37c&scoped=true"
import script from "./FitbackLoverDataTable.vue?vue&type=script&lang=js"
export * from "./FitbackLoverDataTable.vue?vue&type=script&lang=js"
import style0 from "./FitbackLoverDataTable.vue?vue&type=style&index=0&id=80b7b37c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80b7b37c",
  null
  
)

export default component.exports